import {buildServerCall} from '../../services/wcfService';
import {writeLog} from '../../_shared/GWTBridge/invoke/common';
import {getConnection} from '../../_shared/GWTBridge/invoke/genPage';

export function getQuickSearchResults(searchQuery: string, formName: string) {
    const methodName = 'EnterpriseSearchFindForm';
    const reason = 'Quick Search';
    const parameters = {
        text: [`${searchQuery}`],
        filter: [`form:${formName}`],
        start: ['0'],
        rows: ['20'],
        fromDate: ['0'],
        toDate: ['0']
    };
    writeLog(`${reason} (${methodName})`, `queryValue: ${searchQuery}`);
    return buildServerCall(methodName, parameters, reason, false, getConnection);
}
